import { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { LoaderComponent } from '@dnhb/node_package';
import { dispatchMapper } from '../../../shared/wizard/actions';
import { shapeSettings } from '../config';
import GeneralLogoSvg from 'images/shared/general-tool-logo.svg';

class OutputEmpty extends Component {
  render() {
    const { settings, sync } = this.props;

    return (
      <div className="placeholder with-loader no-tablet-and-smaller">
        <div className="flex-container output-empty-content">
          { this.props.syncing ?
            <div className="flex-item">
              <LoaderComponent show /><br />
              <p>Laden</p>
            </div> :
            <div className="flex-item">
              <GeneralLogoSvg className="logo" />
              <p>{ this.props.text }</p>
            </div>
          }
          {settings.enableDisclaimer && (
            <footer>
              <button onClick={() => sync('show_disclaimer', true)}>Disclaimer</button>
            </footer>
          )}
        </div>
      </div>
    );
  }
}

OutputEmpty.propTypes = {
  text: PropTypes.string.isRequired,
  sync: PropTypes.func.isRequired,
  syncing: PropTypes.bool.isRequired,
  settings: shapeSettings.isRequired,
};

export default connect(state => ({
  syncing: state.syncing,
  settings: state.settings,
}), dispatchMapper)(OutputEmpty);
